import React from "react";
import { Card, Form, Row, Col, Button, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../api/fileUpload/fileUpload.hooks";

const WhyChooseUsSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const updateFeature = (index, updates) => {
    const features = [...(data.features || [])];
    features[index] = { ...features[index], ...updates };
    handleChange("features", features);
  };

  const addFeature = () => {
    handleChange("features", [
      ...(data.features || []),
      { title: "", description: "" },
    ]);
  };

  const removeFeature = (index) => {
    handleChange(
      "features",
      (data.features || []).filter((_, i) => i !== index)
    );
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Why Choose Us Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading || ""}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter section heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Paragraph</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.paragraph || ""}
                  onChange={(e) => handleChange("paragraph", e.target.value)}
                  placeholder="Enter section paragraph"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Background Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] &&
                    handleFileUpload("bgImage", e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.bgImage && (
                  <div className="mt-2">
                    <Image
                      src={data.bgImage}
                      alt="Background preview"
                      thumbnail
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Illustration Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] &&
                    handleFileUpload("illustrationImage", e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.illustrationImage && (
                  <div className="mt-2">
                    <Image
                      src={data.illustrationImage}
                      alt="Illustration preview"
                      thumbnail
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3">Features</h6>
          {(data.features || []).map((feature, index) => (
            <div
              key={index}
              className="border rounded p-3 mb-3 bg-light-subtle"
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Feature {index + 1}</h6>
                {(data.features || []).length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeFeature(index)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={feature.title || ""}
                  onChange={(e) =>
                    updateFeature(index, { title: e.target.value })
                  }
                  placeholder="Feature title"
                />
              </Form.Group>
              <Form.Group className="mb-0">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={feature.description || ""}
                  onChange={(e) =>
                    updateFeature(index, { description: e.target.value })
                  }
                  placeholder="Feature description"
                />
              </Form.Group>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addFeature}>
            Add Feature
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default WhyChooseUsSection;
